import PropTypes from 'prop-types';
import './input.css';

/**
 * Reusable Checkbox Group Component
 * Supports multiple checkboxes with controlled state
 */
export const CheckboxGroup = ({
    label = '',
    name = '',
    options = [],
    value = [],
    onChange = () => { },
    onBlur = () => { },
    error = '',
    touched = false,
    disabled = false,
    FormGroupClassName = '',
    LabelClassName = '',
    direction = 'row', // 'row' or 'column'
}) => {
    const handleCheckboxChange = (optionValue) => {
        const currentValues = Array.isArray(value) ? value : [];
        const newValues = currentValues.includes(optionValue)
            ? currentValues.filter((v) => v !== optionValue)
            : [...currentValues, optionValue];
        onChange(newValues);
    };

    return (
        <div className={`form-group ${FormGroupClassName}`}>
            {label && (
                <label
                    style={{ color: error && touched && 'red' }}
                    className={LabelClassName}
                >
                    {label}
                    {error && <span className="login-danger"> *</span>}
                </label>
            )}
            <div
                className={`checkbox-group ${direction === 'column' ? 'd-flex flex-column' : 'd-flex flex-wrap'}`}
                style={{ gap: '10px' }}
            >
                {options.map((option, index) => {
                    const optionValue = option?.value || option;
                    const optionLabel = option?.label || option;
                    const isChecked = Array.isArray(value) && value.includes(optionValue);

                    return (
                        <div className="form-check" key={index}>
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id={`${name}-${index}`}
                                name={name}
                                value={optionValue}
                                checked={isChecked}
                                onChange={() => handleCheckboxChange(optionValue)}
                                onBlur={onBlur}
                                disabled={disabled}
                                style={{
                                    borderColor: error && touched ? 'red' : '',
                                    borderWidth: 1,
                                }}
                            />
                            <label
                                className="form-check-label"
                                htmlFor={`${name}-${index}`}
                                style={{ marginLeft: '5px', cursor: 'pointer' }}
                            >
                                {optionLabel}
                            </label>
                        </div>
                    );
                })}
            </div>
            {error && touched && <div className="text-danger m-1">{error}</div>}
        </div>
    );
};

CheckboxGroup.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    value: PropTypes.array,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    error: PropTypes.string,
    touched: PropTypes.bool,
    disabled: PropTypes.bool,
    FormGroupClassName: PropTypes.string,
    LabelClassName: PropTypes.string,
    direction: PropTypes.oneOf(['row', 'column']),
};
